import { Input as AntdInput } from 'antd';
import { InputProps } from 'antd/lib/input';
import styles from './Input.module.scss';

function Input(props: InputProps) {
  return <AntdInput {...props} className={styles.textInput} />;
}

export default Input;
